<template>
    <b-modal ref="mdlMagazzinoArticoliFornitori" id="mdlMagazzinoArticoliFornitori" :title="modalTitle" size="lg" @show="onShowModal" scrollable centered hide-header-close no-close-on-backdrop no-close-on-esc>
        <div v-if="modalStep === 0">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Nome Articolo:</label>
                    <b-form-input v-model="nomeArticoloDisplay" readonly></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Prezzo Fornitore: <span class="text-danger">*</span></label>
                    <b-input-group prepend="€">
                        <b-form-input type="number" step="0.01" min="0" v-model="jsonDataFornitoreArticolo.prezzoArticoloFornitore"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <label class="sa-label-data">Fornitore Principale:</label>
                    <b-form-checkbox v-model="jsonDataFornitoreArticolo.fornitorePrincipale" :disabled="hasFornitorePrincipale" switch></b-form-checkbox>
                </b-col>
                <b-col cols="12">
                    <label class="sa-label-data">Note:</label>
                    <b-form-textarea rows="4" max-rows="6" v-model="jsonDataFornitoreArticolo.note" placeholder="Note aggiuntive (opzionale)..."></b-form-textarea>
                </b-col>
            </b-row>
            <br />
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="tableModal" selectable select-mode="single" stacked="lg" striped hover :items="listaFornitori" :fields="fieldsFornitori" sort-icon-left head-variant="light" class="sa-b-table" :current-page="currentPage" :per-page="perPage" @row-selected="onRowSelected">
                    <template #table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Caricamento...</strong>
                        </div>
                    </template>
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-container>
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza" variant="outline-secondary" @click="onClickViewFornitore(item)">
                                <font-awesome-icon icon="eye"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                </b-table>
            </div>
        </div>
        <div v-if="modalStep === 1">
            <component ref="fornitoreDetailComponent" :is="currentComponent" v-bind="currentProperties" />
        </div>
        <template #modal-footer>
            <template v-if="modalStep === 0">
                <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
                <b-button size="md" variant="outline-success" @click="saveAssociazioneFornitore">Salva</b-button>
            </template>
            <template v-else>
                <b-button size="md" variant="outline-secondary" @click="backToList"> <font-awesome-icon icon="arrow-left"></font-awesome-icon> Indietro </b-button>
            </template>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import ConfigurazioniMagazzinoFornitoriViewComponent from "./ConfigurazioniMagazzinoFornitoriViewComponent.vue";

export default {
    name: "MagazzinoArticoliFornitoriModalEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError, ConfigurazioniMagazzinoFornitoriViewComponent },
    props: {
        jsonDataArticolo: {
            type: Object,
        },
    },
    computed: {
        nomeArticoloDisplay() {
            return this.jsonDataArticolo?.nomeArticolo || "";
        },
        modalTitle() {
            if (this.modalStep === 0) {
                return "Associa Fornitore";
            } else if (this.modalStep === 1) {
                return "Dettagli Fornitore";
            }
            return "";
        },
    },
    data() {
        return {
            // Paths
            pathResourceFornitori: "/magazzinofornitori",
            pathResourceArticoloFornitore: "/magazzinofornitoriarticoli",
            hasFornitorePrincipale: false,
            //Modal
            modalStep: 0,
            currentComponent: null,
            currentProperties: {},
            // Dati del fornitore-articolo
            jsonDataFornitoreArticolo: {
                id: null,
                idArticolo: null,
                idFornitore: null,
                prezzoArticoloFornitore: null,
                fornitorePrincipale: false,
                note: null,
            },
            // Lista degli ID fornitori da escludere
            idFornitoriEsclusi: [],

            // Paginazione
            currentPage: 1,
            perPage: 10,

            // Liste
            listaFornitori: [],

            // Campi tabella
            fieldsFornitori: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Ragione Sociale",
                    key: "ragioneSocialeFornitore",
                    sortable: false,
                },
                {
                    label: "Codice Fornitore",
                    key: "codiceFornitore",
                    sortable: false,
                },
                {
                    label: "Partita Iva",
                    key: "partitaIvaFornitore",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    methods: {
        show(id, idFornitoriAssociati = [], hasFornitorePrincipale = false) {
            let me = this;
            me.idArticolo = id;
            me.hasFornitorePrincipale = hasFornitorePrincipale;
            me.idFornitoriEsclusi = idFornitoriAssociati;
            console.log("idFornitoriAssociati:", idFornitoriAssociati);
            console.log("Ha già fornitore principale:", me.hasFornitorePrincipale);
            me.$refs.mdlMagazzinoArticoliFornitori.show();
        },
        loadDataFornitori() {
            let me = this;
            let params = { idArticolo: me.idArticolo };
            console.log("Parametri per loadDataFornitori:", params);
            console.log("me.idArticolo:", me.idArticolo);
            UtilityMixin.methods.loadDataResources(me.pathResourceFornitori, params, me.loadDataFornitoriSuccess, me.loadDataFornitoriError);
        },

        loadDataFornitoriSuccess(response) {
            // let me = this;
            /*  me.listaFornitori = response.data.data.list;
            console.log("Fornitori disponibili caricati:", me.listaFornitori.length); */
            let me = this;
            let tuttiFornitori = response.data.data.list;
            // Filtrare escludendo i fornitori già associati
            me.listaFornitori = tuttiFornitori.filter((fornitore) => !me.idFornitoriEsclusi.includes(fornitore.id));
        },

        loadDataFornitoriError(error) {
            console.log(error);
        },

        saveAssociazioneFornitore() {
            let me = this;

            if (!me.jsonDataFornitoreArticolo.idFornitore) {
                me.$bvToast.toast("Selezionare un fornitore", {
                    title: "Attenzione",
                    variant: "warning",
                    solid: true,
                });
                return;
            }
            me.jsonDataFornitoreArticolo.idArticolo = me.jsonDataArticolo.id;
            /* if (me.listaFornitori.length > 0){
                me.jsonDataArticolo.fornitorePrincipale = false,
            } */
            UtilityMixin.methods.saveResource(me.pathResourceArticoloFornitore, me.jsonDataFornitoreArticolo, me.saveAssociazioneSuccess, me.saveAssociazioneError);

            console.log("Salvo i seguenti dati:", me.jsonDataFornitoreArticolo);
        },
        saveAssociazioneSuccess(response) {
            let me = this;
            me.$emit("saveAssociazione", response);
            console.log("SUCCESS SAVE");
            me.onCloseModal();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveAssociazioneError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onCloseModal() {
            let me = this;
            me.resetForm();
            me.$refs.mdlMagazzinoArticoliFornitori.hide();
        },
        onShowModal() {
            let me = this;
            me.loadDataFornitori();
        },
        onRowSelected(items) {
            let me = this;

            if (items.length > 0) {
                const selectedItem = items[0];
                console.log("Selected fornitore ID:", selectedItem.id);
                me.jsonDataFornitoreArticolo.idFornitore = selectedItem.id;
            } else {
                me.jsonDataFornitoreArticolo.idFornitore = null;
                me.jsonDataFornitoreArticolo.fornitorePrincipale = false;
            }
        },
        resetForm() {
            let me = this;
            me.jsonDataFornitoreArticolo = {
                id: null,
                idArticolo: me.jsonDataArticolo?.id || null,
                idFornitore: null,
                fornitorePrincipale: false,
                prezzoArticoloFornitore: null,
                note: null,
            };
            me.idFornitoriEsclusi = [];
            me.hasFornitorePrincipale = false;
            me.modalStep = 0;
            me.currentComponent = null;
            me.currentProperties = {};
        },
        /* onClickViewFornitore(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoFornitoriModalEdit.show(item, true);
        }, */

        onClickViewFornitore(item) {
            let me = this;
            me.modalStep = 1;
            me.currentComponent = ConfigurazioniMagazzinoFornitoriViewComponent;
            me.currentProperties = {
                fornitoreData: item,
            };
        },

        backToList() {
            let me = this;
            me.modalStep = 0;
            me.currentComponent = null;
            me.currentProperties = {};
        },
    },
};
</script>
